<template>
    <div class="p-2 w-full border-gray rounded-lg">

      <div class="font-semibold text-black flex items-center" :class="{'text-xl': readonly, 'text-lg': !readonly, 'opacity-50': !value}">
        <feather-icon :icon="icon" class="w-6" />
        <span class="ml-2">{{title | lowercase}}</span>
      </div>

      <vs-progress
       v-if="readonly"
      :height="5"
      :percent="value"
      color="primary"/>

      <vs-slider
        v-else
        v-model="innerModel"
        color="black"
        :step="1"
        max="100"
        :height="15"
        class="m-0 my-1 first-chapter-slider"
      />
      <GoodNotSoGood v-if="!readonly"/>

    </div>

</template>

<script>
// import JourneyDay from './JourneyDay'
// import * as DateHelper from '@/helpers/date'
// import _  from 'lodash'

export default {
  components: {
  },
  props: ['value', 'icon', 'title', 'readonly', 'tooltipText'],
  data () {
    return {
      innerModel: 50,
    }
  },
  watch: {
    'value': {
      immediate: true,
      handler (value) {
        this.innerModel = value
      }
    },
    'innerModel': {
      immediate: false,
      handler (value) {
        this.$emit('input', value)
      }
    },
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="scss">
.first-chapter-slider .vs-slider{
  height: 8px;
}


</style>
